<template>
  <two-column-layout
      :id="$route.params.id"
      back-button-tab-selector="sfxbackbutton"
      sub-menu-selector="librarypanel"
      tab-selector="assemblytab"
  >
    <template slot="mainContent">
      <div class="row">
        <h1 class="w-100 mb-3 ml-3">
          {{ name ? name : $store.getters.getAssemblyName($route.params.id) }}
        </h1>

        <!--UPDATE 3D Data-->
        <div
            v-if="showUpdatePanel"
            class="col-12 col-md-8"
        >
          <info-panel
              :collapsible="true"
              :initially-collapsed="true"
              info-panel-header="UpdateSfxData"
              preview-id="sfxImport"
              class="new-style dark"
          >
            <div slot="info" class="col-12 col-md-8 mb-3 p-3">
              <div v-if="!versionStarted && !startingVersion ">
                <div class="col-12 col-md-8 form-error border-radius">
                  {{ $t('makeAVersionFirst') }}
                </div>
                <div class="settings-button d-inline-block mr-1 mb-2"
                     @click="createVersion">
                  {{ $t('createNewType', {type: 'backup'}) }}
                </div>
                <br/>
                {{ $t('Update3dHint') }}<br/>
                <div class="settings-button d-inline-block mt-3"
                     @click="$router.push('/library/3d-data/' + $route.params.id +'/update-cad')">
                  {{ $t('Update3dData') }}
                </div>
              </div>
              <loading-panel
                  v-else-if="startingVersion"
                  :time-in-seconds="0"
                  message="pleaseWait"
              />

              <div v-else-if="versionStarted">
                <div class="col-12 col-md-8 bg-dark p-3">
                  {{ $t('versioningProcessStarted') }}
                </div>
              </div>
            </div>
          </info-panel>

        </div>

        <!--UPDATE META DATA-->
        <div
            v-if="showUpdatePanel"
            class="col-12 col-md-8"
        >
          <info-panel
              :collapsible="true"
              :initially-collapsed="true"
              info-panel-header="UpdateMetaData"
              preview-id="fileProcessing"
              class="new-style dark"
          >
            <div slot="info" class="row p-2">
              <meta-data-updater
                  v-if="content"
                  :remote-content="content"
                  @triggered="redirectToGeneralTab"
              />
            </div>
          </info-panel>
        </div>


        <!--UPDATE INSTANCE DATA-->
        <div
            v-if="showUpdatePanel"
            class="col-12 col-md-8"
        >
          <info-panel
              :collapsible="true"
              :initially-collapsed="true"
              info-panel-header="UpdateHierarchy"
              preview-id="fileProcessing"
              class="new-style dark"
          >
            <div slot="info" class="row p-2">
              <instance-updater
                  v-if="content"
                  :remote-content="content"
                  @triggered="redirectToGeneralTab"
              />
            </div>
          </info-panel>
        </div>

        <!--APPLY MATERIAL MAPPING-->
        <div
            v-if="showUpdatePanel"
            class="col-12 col-md-8 meta-field-value"
        >
          <info-panel
              :collapsible="true"
              :initially-collapsed="true"
              info-panel-header="Apply Material Mapping"
              preview-id="matmap"
              class="new-style dark"
          >
            <div slot="info" class="pl-3">
              <apply-material-mapping
                  v-if="$store.getters.getAssemblyOrganization($route.params.id)"
                  :asset-id="$route.params.id"
                  @triggered="redirectToGeneralTab"
              >
              </apply-material-mapping>
            </div>
          </info-panel>
        </div>

        <!--ITEM IS PROCESSING-->
        <div v-if="showMessage" class="col-12 col-md-8">
          {{ $t("UpdateProcessStarted") }}
        </div>
        <div v-else-if="!canUpdateAssemblyMetaData && permissionsChecked">
          <div class="col-12 col-md-8 form-error p-2 ml-3 mt-2">
            {{ $t("NoPermissionUpdateAssembly") }}
          </div>
        </div>
        <div
            v-else-if="!showUpdatePanel && !loading"
            class="col-12 col-md-8 form-error p-2 ml-3 mt-2"
        >
          {{ $t("AssemblyProcessing") }}
        </div>
        <!--Please wait message while loading pipeline status-->
        <div v-if="loading" class="col-12 col-md-8 mb-1">
          <loading-panel
              message="loading"
          />
        </div>
        <div class="w-100" />
        <div v-if="canUpdateAssemblyMetaData"
             class="ml-3 mb-2 d-inline-block settings-button"
             @click="loadAssembly">
          {{ $t('reloadStatus') }} <icon type="rotate-right" class="ml-1"/>
        </div>
      </div>
    </template>
  </two-column-layout>
</template>

<script>
import TwoColumnLayout from "../layouts/OneColumnSidebarLeft";
import InfoPanel from "@/components/InfoPanel";
import {email} from "vuelidate/lib/validators";
import VuelidateMixin from "@/components/mixins/VuelidateMixin.js";

import ApplyMaterialMapping from "@/components/assemblies/ApplyMaterialMapping";
import LoadingPanel from "../components/LoadingPanel";
import MetaDataUpdater from "../components/assemblies/MetaDataUpdater";
import InstanceUpdater from "../components/assemblies/InstanceUpdater";
import {getIsCurrentlyProcessing, getMappedTask, getPipelineTask} from "@/pipelineUtils";
import Icon from "@/components/Icon.vue";

export default {
  name: "SFXEdit",
  components: {
    TwoColumnLayout,
    InfoPanel,
    ApplyMaterialMapping,
    LoadingPanel,
    MetaDataUpdater,
    InstanceUpdater,
    Icon
  },
  mixins: [VuelidateMixin],
  data() {
    return {
      /**
       * Display only: name of the assembly
       * */
      name: '',

      email: this.$store.getters.getUserEmail(this.$store.getters.getCurrentUserId),

      content: {},
      canUpdateHierarchy: false,
      canUpdateAssemblyMetaData: false,
      permissionsChecked: false,
      teams: [],

      showMessage: false,
      hasNoVersions: true,
      versionStarted: false,
      startingVersion: false,
      loading: false,
      pipelineTask: '',
      pipelineTaskId: '',
      forceBlockUpdates: false,
      dataRow: {},
    };
  },
  validations: {
    email: {
      email,
    },
  },
  computed: {
    showUpdatePanel() {
      return !this.forceBlockUpdates && this.canUpdateAssemblyMetaData && !this.isCurrentlyProcessing && !this.loading;
    },
    mappedTask() {
      return getMappedTask(this.dataRow);
    },
    isCurrentlyProcessing() {
      return getIsCurrentlyProcessing(this.mappedTask);
    },
  },
  beforeMount() {
    this.init();
  },
  methods: {
    async init() {
      await this.loadAssembly();
      await this.setPermissions();
    },
    redirectToGeneralTab() {
      this.$router.push(`/library/3d-data/assembly/${this.$route.params.id}/general`);
    },
    async createVersion() {
      this.startingVersion = true;
      await this.$store.dispatch('clientAssetToPipeline', {
        id: this.$route.params.id,
        type: 'createVersion',
        virtualMachine: null,
        config: JSON.stringify({
          email: this.email,
          sendMails: true,
          lang: this.$i18n.locale ? this.$i18n.locale : 'en',
        })
      }).then(() => {
        this.startingVersion = false;
        this.versionStarted = true;
      }).catch(e => {
        // todo: show error
        console.log(e);
      })
    },
    async setPermissions() {
      this.canUpdateHierarchy = await this.$store.dispatch("checkTeamOrgPermission", {
            teams: this.teams,
            op: "updateSfxHierarchy",
            organizationId: this.$store.getters.getAssemblyOrganization(this.$route.params.id),
          }
      );
      this.canUpdateAssemblyMetaData = await this.$store.dispatch("checkTeamOrgPermission", {
            teams: this.teams,
            op: "write",
            organizationId: this.$store.getters.getAssemblyOrganization(this.$route.params.id),
          }
      );
      this.permissionsChecked = true;
    },
    async loadAssembly() {
      this.loading = true;
      this.showMessage = false;
      await this.$store.dispatch("loadAssembly", {
        id: this.$route.params.id,
        include: 'tags,metaSets,teams,versions,TaskManagerRow',
      }).catch((e) => {
        if (e.status === 401) {
          this.$router.push("/access-denied");
        } else if (e.status === 404) {
          this.$router.push('/not-found')
        }
      }).then((data) => {
        const {taskManagerRows, teams, versions, name, content} = data;
        this.setContent(content);
        this.setPipelineTask(taskManagerRows);
        this.teams = teams ? teams : [];
        this.hasNoVersions = versions && versions.length === 0;
        this.name = name;
        this.loading = false;
      })
    },
    setPipelineTask(taskManagerRows) {
      const {pipelineTask, pipelineTaskId, dataRow} = getPipelineTask(taskManagerRows);
      this.pipelineTask = pipelineTask;
      this.pipelineTaskId = pipelineTaskId;
      this.dataRow = dataRow;
    },
    setContent(content) {
      this.content = {
        pipeline: {
          sendMails: true,
          email: ""
        }
      };

      if(!content) {
        return;
      }

      try {
        content = JSON.parse(content);
      } catch (e) {
        console.error(e);
      }
      const {pipeline} = content;
      if (!pipeline) {
        return;
      }
      const {email, showInitialForm} = pipeline;
      if (email) {
        this.email = email;
      }
      this.forceBlockUpdates = showInitialForm;
    },

  },
};
</script>

<style lang="scss" scoped>
.connection-delete {
  cursor: pointer;
}
</style>
